import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeContextProvider from './contexts/ThemeContext';
import ReactGA4 from 'react-ga4';  // Utiliser react-ga4 pour GA4

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

// Ton ID de suivi Google Analytics 4 (GA4)
const GA_TRACKING_ID = 'G-7WL5EM4WM7';  // Remplace avec ton ID de flux GA4

// Initialiser GA4
ReactGA4.initialize(GA_TRACKING_ID);

// Suivi des pages vues
ReactGA4.send('pageview', window.location.pathname + window.location.search);

ReactDOM.render(
  <ThemeContextProvider>
    <App />
  </ThemeContextProvider>,
  document.getElementById('root')
);

reportWebVitals();
